import React from 'react';
import { Badge, tokens } from '@fluentui/react-components';
import { IDependentValues } from '../../../@types/workspaceTypes';
import { Paths } from '../../../@types/keyOfNested';
import getIn from '../../connectedForm/utils/getIn';

/**
 * Displays a badge for each item in the provided value array
 *
 * @param key - key of the field
 * @param value - array of objects
 * @param dependentValues - options
 */
export default function ListFormatter<T>({
  key,
  value,
  dependentValues,
}: {
  key: string;
  value: Array<T>;
  dependentValues: IDependentValues;
}) {
  const path: Paths<T> | undefined = dependentValues?.options?.path;

  if (!path) {
    console.error('ListFormatter: path is not configured');
    return null;
  }

  if (value && !Array.isArray(value)) {
    console.error('ListFormatter: value is not an array');
    return null;
  }

  return value.map((item) => {
    const displayValue = getIn(item, path);
    return (
      <Badge
        key={`${key}_${displayValue}`}
        color={'informative'}
        shape="rounded"
        style={{ marginRight: tokens.spacingHorizontalS }}
      >
        {displayValue}
      </Badge>
    );
  });
}
